import { useState, useEffect } from "react";
import { EMPLOYEE_MANAGEMENT_SERVICE } from "src/utils/Api";
import __ from "src/utils/Translations";
import sendBatchRequests from "src/utils/Api/sendBatchRequests";

export default function useAhrRoles(
  asOption = false,
  filterField = null,
  filterValue = null,
  idAsIri = false,
  noFetching = false
) {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () =>
      sendBatchRequests({
        skipAction: noFetching,
        filterField,
        filterValue,
        idAsIri,
        asOption,
        IRI_PREFIX,
        requestParams: {
          service: EMPLOYEE_MANAGEMENT_SERVICE,
          path: "/ahr-roles",
          method: "GET",
          mockData,
          itemsPerPage: 100,
          additionalParams: {
            ahr: true,
          },
        },
        setData,
      });

    fetchData();
  }, [filterField, filterValue, idAsIri, asOption, noFetching, setData]);

  return data;
}

export const IRI_PREFIX = "/api/employee-management/v1/rest/ahr-roles";

export const mockData = [
  {
    id: "a43275e4-eeb2-11ea-adc1-0242ac1200021",
    name: "AHR_MAX_test",
    description: "grupa AHR_MAX",
    employeeIds: [
      "1a43275e4-eeb2-11ea-adc1-0242ac120002",
      "2a43275e4-eeb2-11ea-adc1-0242ac120002",
    ],
  },
];
